module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("lEKoN"))).then(() => parcelRequire('cvs7o'));